import { type Stores } from '~/composables/useStores'

type Storefront = Stores['storefronts']['Result'] | null | undefined

const KITCHEN_ROLES = ['cook', 'barmen', 'manager']
const IN_HOUSE_ROLES = ['waiter', 'manager']
const TASKS_ROLES = ['cook', 'barmen', 'waiter', 'manager']

// Single source of truth for role/feature access. Used by the router guard and
// by App.vue's post-login redirect so both decide the same way.

// Where a freshly-authenticated user should land, by role.
export const roleHome = (
  role: string,
  storefront: Storefront,
): string | null => {
  if (['cook', 'barmen'].includes(role)) return 'kitchen'
  if (storefront?.inHouseService.enabled) return 'in-house'

  return null
}

// Route-level access control. Routes without an explicit rule (stock, settings,
// index) are open to any authenticated user, matching prior behaviour.
export const canAccessRoute = (
  name: string,
  role: string,
  storefront: Storefront,
): boolean => {
  if (name === 'kitchen') {
    return !!storefront?.inHouseService.enabled && KITCHEN_ROLES.includes(role)
  }

  if (name === 'in-house') {
    return !!storefront?.inHouseService.enabled && IN_HOUSE_ROLES.includes(role)
  }

  if (name === 'tasks') {
    return TASKS_ROLES.includes(role)
  }

  return true
}
